import {EntityType} from "../../gd/const/item"
import ModelEntity from "../model-entity"
import User from "../user/user"
import {ProjectAccess, ProjectRole, UserInheritance} from "../../gd/const/project"
import ProjectSession from "../project/project-session"
import {ProjectUserAccessControl} from "./access/acl"
import Team from "../team/team"

export default class ProjectUserSession extends ModelEntity {


    public userId           : ID
    public teamId           : ID // ??? it can be un defined !!!
    public projectId        : ID
    public projectRole      : ProjectRole
    public access           : ProjectAccess //| null
    public inheritance?     : UserInheritance

    // I think we should add them !
    // public inheritance?    : UserInheritance
    // public watchAll        : boolean

    public _project?        : ProjectSession // cache
    public _user?           : User // cache

    constructor(data: any) {

        const userId        = _.get(data, 'userId')
        const teamId        = _.get(data, 'teamId')
        const projectId     = _.get(data, 'projectId')
        // const id = '{0}-{1}'.f(projectId, userId)

        let id :  string
        if (teamId) {
            id = '{0}-team-{1}'.f(projectId, teamId)
        } else {
            id = '{0}-{1}'.f(projectId, userId)
        }

        super(id, EntityType.PROJECT_USER)

        // super(data);

        this.userId         = userId
        this.teamId         = teamId
        this.projectId      = projectId
        this.projectRole    = data['projectRole']
        this.access         = data['access']
        this.inheritance    = data.inheritance

    }

    // GETTERS

    get isUser():boolean {
        return !!this.userId
    }

    get isTeam():boolean {
        return !!this.teamId
    }

    get project():ProjectSession {
        // do we need cache here ? this._project
        return gd.session.projects.get(this.projectId)!
    }

    get user() {
        return gd.session.users.get(this.userId)!
    }

    get team(): Team {
        return gd.session.teams.get(this.teamId)!
    }

    // Helpers

    get isClient():boolean {
        return this.access === ProjectAccess.CLIENT
    }


    get acl():ProjectUserAccessControl {
        return new ProjectUserAccessControl(this)
    }

}
